export default {
  validate: {
    validateIncrementDate: 'Ngày ghi tăng phải lớn hơn Ngày mua',
    validateUsedDate: 'Ngày sử dụng phải lớn hơn Ngày ghi tăng',
    validateDepreciationDate: 'Ngày BĐ tính hao mòn phải lớn hơn Ngày ghi tăng',
    validateDevaluationDate: 'Ngày bắt đầu tính KH phải lớn hơn hoặc bằng Ngày ghi tăng',
    validatePeriodDepreciationAmount: 'Giá trị hao mòn/khấu hao năm phải nhỏ hơn hoặc bằng Nguyên giá',
    validateDevaluationAmount: 'Giá trị tính khấu hao phải nhỏ hơn hoặc bằng Nguyên giá',
    validateRemainingLifeTime: 'Thời gian sử dụng còn lại phải nhỏ hơn hoặc bằng Thời gian sử dụng',
    validateEndYear: 'Đến năm phải lớn hơn hoặc bằng Ngày bắt đầu tính hao mòn',
    validateAccumDepreciationAmount: 'Nguyên giá phải bằng Hao mòn/khấu hao lũy kế cộng với Giá trị còn lại',
    validateAccumDepreciationAmount2: 'Tài sản chỉ tính khấu hao nên Khấu hao lũy kế phải bằng Hao mòn/khấu hao lũy kế',
    validatePeriodDevaluationAmount: 'Giá trị khấu hao tháng phải nhỏ hơn Nguyên giá',
    validateAccumDevaluationAmount: 'Giá trị khấu hao lũy kế phải nhỏ hơn Nguyên giá',
    validateRemainingDevaluationLifeTime: 'Thời gian KH còn lại phải nhỏ hơn Thời gian tính khấu hao',
  },
  warning: {
    orgPrice: {
      WaringOrgPriceAmountTitle: 'Chưa nhập Nguyên giá',
      WaringOrgPriceAmountMessage: 'Chưa nhập nguyên giá. Bạn có muốn nhập không?',
    },
    duplicateQuantity: {
      WaringDuplicateQuantityMessage: 'Số lượng nhân bản là {0}. Bạn có muốn thực hiện hay không?',
      WaringDuplicateQuantityTitle: 'Thực hiện nhân bản',
    },
  },
  FixedAssetList: {
    notice: {
      IsCanNotBeIncreased: {
        IsCanNotBeIncreasedMessage: 'Bạn không thể thực hiện ghi tăng cho tài sản đã ghi tăng.',
        IsCanNotBeIncreasedTitle: 'Không thể ghi tăng',
      },
      IsCanNotBeDereased: {
        IsCanNotBeDereasedMessage: 'Bạn không thể ghi giảm cho tài sản đã ghi giảm.',
        IsCanNotBeDereasedMessage1: 'Bạn không thể ghi giảm cho tài sản chưa thực hiện ghi tăng.',
        IsCanNotBeDereasedTitle: 'Không thể ghi giảm',
      },
      IsCanNotBeAdjusted: {
        IsCanNotBeAdjustedMessage: 'Bạn không thể thực hiện đánh giá lại cho tài sản đã ghi giảm.',
        IsCanNotBeAdjustedMessage1: 'Bạn không thể thực hiện đánh giá lại tài sản chưa thực hiện ghi tăng.',
        IsCanNotBeAdjustedTitle: 'Không thể đánh giá lại',
      },
    },
  },

  ValidateTransfer: {
    DuplicateDepartment: 'Thông tin đến Phòng/Ban không được trùng với thông tin từ Phòng/Ban.',
    DuplicateFixedAsset: 'Mã tài sản đã có trong danh sách. Xin vui lòng kiểm tra lại.',
    DeleteFixFixedAssetTitle: 'Xóa tài sản',
    DeleteFixFixedAssetContent:
      'Tài sản <span class="color-green">{0}</span> ghi tăng sau ngày <span class="color-green">{1}</span> nên không đủ điều kiện điều chuyển.',
  },
};
